import { BitfODataPathBuilder } from '@bitf/core/parsers/odata-parser/bitf-odata-path.builder';

export class AppPathBuilder extends BitfODataPathBuilder {}
